import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { Token } from 'symbiosis-js-sdk'

import Asset from '~/components/Asset'
import Text from '~/components/Text'
import Title from '~/components/Title'
import { useGetOriginLikeToken } from '~/hooks/useGetOriginLikeToken'

import css from './TokenPairCard.pcss'

interface TokenPairCardDetail {
	label: ReactNode
	value: ReactNode
}

interface TokenPairCardProps extends React.HTMLAttributes<HTMLDivElement> {
	tokens: [Token, Token]
	details?: TokenPairCardDetail[]
}

export const renderTitle = (a: Token, b: Token): string =>
	b.chainFrom ? `${a.chain?.name!} / ${b?.chainFrom?.name}` : a?.chain?.name!

const TokenPairCard: React.FC<TokenPairCardProps> = ({
	tokens,
	className,
	details = [],
	...rest
}) => {
	const [aToken, bToken] = tokens

	const originLikeBToken = useGetOriginLikeToken(bToken)

	return (
		<div
			className={classNames(css.card, className, {
				[css.hasOnClick]: !!rest.onClick,
			})}
			{...rest}
		>
			<div className={css.header}>
				<Title size="3">{renderTitle(aToken, originLikeBToken)}</Title>
			</div>
			<div className={css.assets}>
				<div className={css.asset}>
					<Asset token={aToken} minimal />
				</div>
				<div className={css.asset}>
					<Asset token={originLikeBToken} minimal />
				</div>
			</div>
			<div className={css.details}>
				{details.map((detail, index) => (
					<div className={css.detail} key={`detail-${index}`}>
						<Text size="S" color="secondary" className={css.label}>
							{detail.label}
						</Text>
						<Text size="L" className={css.value}>
							{detail.value}
						</Text>
					</div>
				))}
			</div>
		</div>
	)
}

export default TokenPairCard
